import * as React from "react";

import "./select-modal.scss";

import { bindInput } from "@Common/react/bind-input";
import { cs }        from "@Common/react/chain-services";
import { UseState }  from "@Common/react/use-state";
import { Select }    from "@Common/ui-components/heavy/common/design2/select/select";

export const SelectModal = ({list, selectLabel, displayOtherField = false, messageLine1, messageLine2=null, messageLine3=null, button1Label="Cancel", button2Label="OK", button1Action, button2Action}) => cs(
    ["selection", (_, next) => UseState({
        next,
    })],
    ["otherInput", (_, next) => UseState({
        next,
    })],
    ({selection, otherInput}) => (
        <div className="select-modal-k3o">
            <div className="content">
                <div className="message">
                    <p className="">
                        {messageLine1}
                    </p>
                    {messageLine2 && <p>
                        {messageLine2}
                    </p>}
                    {messageLine3 && <p>
                        {messageLine3}
                    </p>}
                </div>
                <div className="select">
                    <div className="select-label">{selectLabel}</div>
                    {Select({
                        className: "select-input",
                        expandClassName: "select-input-expand",
                        list: (displayOtherField ? (
                            [null, ...list]
                        ) : (
                            [null, ...list, "Other"]
                            )),
                            itemToLabel: (o) => o == null ? "Please Select..." : o,
                            isSelected: (o) => selection.value ? o === selection.value : o == null,
                        onChange: (o) => selection.onChange(o),
                        xdQaName: selectLabel,
                        forcedExpandLeft: 1,
                    })}
                </div>
            </div>
            {selection.value === "Other" && <div className="select">
                <div className="select-label">Please Explain:</div>
                <input {...{
                    ...bindInput({
                        ...otherInput
                    }),
                    "xd-qa-type": "textbox",
                    "xd-qa-name": "Other",
                    className: "other",
                }}/>
            </div>}
            <div className="footer">
                <button className="cancel" onClick={button1Action} xd-qa-type="button" xd-qa-name={button1Label}>{button1Label}</button>
                {selection.value && (selection.value !== "Other" || !!otherInput.value) ? (
                    <button className="proceed"    onClick={() => button2Action({selection, otherInput})} xd-qa-type="button" xd-qa-name={button2Label}>{button2Label}</button>
                ) : (
                    <button className="proceed disabled" xd-qa-type="button" xd-qa-name={button2Label}>{button2Label}</button>
                )}
            </div>
        </div>
    )
);
